import React from 'react';
import './Accommodations.css';

const Accommodations = ({ config }) => {
  if (!config?.content?.accommodations?.enabled || !config?.resort) return null;

  return (
    <section id="accommodations" className="accommodations section">
      <div className="container">
        <h2 className="section-title" style={{ fontFamily: config.design.fonts.heading, color: config.design.colors.primary }}>
          Accommodations
        </h2>
        <div className="accommodations-message" style={{ fontFamily: config.design.fonts.body, color: config.design.colors.secondary }}>
          {config.content.accommodations.message.split('\n').map((line, index) => (
            <p key={index} style={{ marginBottom: '1rem' }}>
              {line.trim() || '\u00A0'}
            </p>
          ))}
        </div>
        <div className="accommodations-list">
          <div className="hotel-card">
            <h3 className="hotel-name" style={{ fontFamily: config.design.fonts.heading, color: config.design.colors.primary }}>
              {config.resort.name}
            </h3>
            <p className="hotel-address" style={{ fontFamily: config.design.fonts.body, color: config.design.colors.secondary }}>
              {config.resort.address}
            </p>
            <p className="hotel-phone" style={{ fontFamily: config.design.fonts.body, color: config.design.colors.secondary }}>
              Phone: {config.resort.phone}
            </p>
            <p style={{ marginTop: '15px', textAlign: 'center' }}>
              <a
                href={`https://www.google.com/maps/search/?api=1&query=${config.resort.gpsCoordinates.latitude.replace('°', '').replace(' N', '')},${config.resort.gpsCoordinates.longitude.replace('°', '').replace(' E', '')}`}
                target="_blank"
                rel="noopener noreferrer"
                className="maps-link"
                style={{
                  fontFamily: config.design.fonts.body,
                  color: config.design.colors.primary,
                  fontWeight: 600,
                  textDecoration: 'none',
                  borderBottom: `2px solid ${config.design.colors.primary}`,
                  paddingBottom: '2px',
                  transition: 'all 0.3s ease',
                  display: 'inline-block'
                }}
              >
                Open in Maps →
              </a>
            </p>
            <p className="accommodations-note" style={{ 
              marginTop: '2rem', 
              marginBottom: '1rem',
              textAlign: 'center',
              fontFamily: config.design.fonts.body, 
              color: config.design.colors.secondary,
              fontStyle: 'italic'
            }}>
              (If you want accommodation for the 6th or 7th (or both), please reach out to Aman.)
            </p>
            {config.content.accommodations.reservationCode && (
              <p className="hotel-code" style={{ fontFamily: config.design.fonts.body, color: config.design.colors.accent }}>
                Reservation Code: <strong>{config.content.accommodations.reservationCode}</strong>
              </p>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Accommodations;

